import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';

function ComboPadraoMultiple({ options, label, itens, onSelectionChange }) {
    const [selectedValues, setSelectedValues] = useState([]);
    const selectRef = useRef(null); // mantém a referência do Select

    // definindo o estado inicial para selecionar todos os itens
    useEffect(() => {
        setSelectedValues(options); // inicializa com todos os itens marcados
    }, [options]); // executa quando as opções mudam

    const handleCheckboxChange = (event, value) => {
        event.stopPropagation(); // impede o clique de afetar o Select

        const newSelectedValues = selectedValues.includes(value) ? selectedValues.filter(
            (item) => item !== value
        ) : [...selectedValues, value];

        setSelectedValues(newSelectedValues);

        // chama a função de callback para notificar o componente pai
        if (onSelectionChange) {
            onSelectionChange(newSelectedValues);
        }
    };

    return (
        <div>
            <FormControl fullWidth>
                <InputLabel id="multiple-select-label">
                    {label}
                </InputLabel>

                <Select
                    labelId="multiple-select-label"
                    id="multiple-select"
                    multiple
                    value={selectedValues.map(item => item.item)}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 200,
                                overflow: 'auto',
                                overflowX: 'hidden'
                            }
                        },
                        getContentAnchorEl: null, // evita o recálculo da posição do menu
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        }
                    }}
                    ref={selectRef} // usa ref para manter a referência
                >
                    {itens.map((item) => (
                        <MenuItem
                            key={item.id}
                            value={item.id}
                            disableRipple
                            style={{
                                height: 30,
                                width: '100%'
                            }}
                        >
                            <Checkbox
                                checked={selectedValues.includes(item)}
                                onChange={(e) => handleCheckboxChange(e, item)}
                            />

                            <ListItemText
                                primary={item.item}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default ComboPadraoMultiple;